import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	CardBody,
	Card,
	CardHeader,
	Row,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { ODataGrid } from '../../Components/OElements/ODataGrid.js';
import { getWarehouseAssignedItemsSummary, getWarehouseAssignedItemsSummaryQuery } from '../../slices/thunks';
import { useUser } from '../../Components/Hooks/useUserHooks.js';

const PersonalProtectiveEquipmentMotionList = ({ month, year }) => {
	const dispatch = useDispatch();
	const history = useNavigate();
	const { user } = useUser();


	const selectorCategories = createSelector(
		state => state.PersonalProtectiveEquipments,
		data => ({
			dataList: data.personalProtectiveEquipmentList,
			isLoadingList: data.isLoadingList,
			isPersonalProtectiveEquipmentSuccess: data.isPersonalProtectiveEquipmentSuccess,
		})
	);

	const { dataList, isLoadingList } = useSelector(selectorCategories);



	const columns = useMemo(
		() => [
			{ header: 'Entrega', accessorKey: 'delivery_date', dataType: 'date', size: 'auto' },
			{ header: 'Devolución', accessorKey: 'receive_date', dataType: 'date', size: 'auto' },
			{ header: 'Transacción', accessorKey: 'doc_num', size: 'auto' },
			{ header: 'Centro Costo', accessorKey: 'cost_center', size: 'auto' },
			{ header: 'Departamento', accessorKey: 'management_name', size: 'auto', dataType: 'multi-select', visible: false },
			{ header: 'Empresa', accessorKey: 'company_name', size: 'auto', dataType: 'multi-select' },
			{ header: 'Establecimiento', accessorKey: 'establishment_name', size: 'auto', dataType: 'multi-select' },

			{ header: 'Código Bodega', accessorKey: 'warehouse_code', size: 'auto' },
			{ header: 'Bodega', accessorKey: 'warehouse_name', size: 'auto', dataType: 'multi-select' },
			{ header: 'Empresa Bodega', accessorKey: 'warehouse_company_name', size: 'auto' },

			{ header: 'Código SAP', accessorKey: 'item_code_sap', size: 'auto' },
			{ header: 'Elemento', accessorKey: 'item_name', size: 'auto', dataType: 'multi-select' },
			{ header: 'Cantidad', accessorKey: 'quantity', size: 'auto' },
			{ header: 'Unidad', accessorKey: 'unit_measurement_name', size: 'auto' },
			{ header: 'Grupo Elemento', accessorKey: 'warehouse_group_code', size: 'auto' },

		],
		[]
	);
	;

	const getDataFuncWithMonthYear = params => {
		return getWarehouseAssignedItemsSummaryQuery({
			...params,
			month,
			year,
		});
	};

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>

						<CardBody>
							<ODataGrid
								columns={columns}
								getDataFunc={getDataFuncWithMonthYear}
								remoteOperations={{
									pagination: true,
									sorting: true,
									filtering: true,
								}}
								// data={dataList || []}
								nameFile={'movimientos_epp'}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</React.Fragment>
	);
};

export default PersonalProtectiveEquipmentMotionList;
